import React, { forwardRef } from "react";
import { AccordionHelper } from "components/displays";
import { Form, FormBuilder } from "@redriver/cinnamon";
import PenSvg from "features/../../../shared/assets/pen.svg";
import SaveSvg from "features/../../../shared/assets/save.svg";
import { IconButton } from "features/../../../shared/components/buttons";
import { Button } from "semantic-ui-react";
import {
  getDocumentNotificationInboxes,
  setDocumentNotificationInboxes,
} from "features/Dealers/DealerOffice/Settings/actions";

const DocumentNotificationInboxes = forwardRef(
  ({ settingsId, collapsed, toggleVisibility }, ref) => {
    return (
      <div ref={ref}>
        <AccordionHelper
          title="Document Notification Inboxes"
          collapsed={collapsed}
          toggleVisibility={toggleVisibility}
        >
          <FormBuilder
            initialReadOnly
            loadAction={getDocumentNotificationInboxes}
            loadParams={settingsId}
            submitAction={setDocumentNotificationInboxes}
            submitParams={{ settingsId }}
            renderForm={(formProps, state, events) => {
              return (
                <Form {...formProps}>
                  <div className="header">
                    <div className="actions form-header">
                      {!state.readOnly && (
                        <Button
                          primary
                          className="cancel-title-action"
                          content="Cancel"
                          onClick={events.onReset}
                        />
                      )}
                      <IconButton
                        primary
                        icon={state.readOnly ? PenSvg : SaveSvg}
                        content={state.readOnly ? "Edit" : "Save"}
                        onClick={() =>
                          state.readOnly
                            ? events.onToggleReadOnly()
                            : events.onSubmit({ reset: ["readOnly"] })
                        }
                        className={
                          !state.readOnly ? "positive-title-action" : null
                        }
                      />
                    </div>
                  </div>
                  <Form.Input
                    field="supplierAdminInbox"
                    label="Supplier Admin Inbox"
                    placeholder="Email..."
                  />
                </Form>
              );
            }}
          />
        </AccordionHelper>
      </div>
    );
  },
);

export default DocumentNotificationInboxes;
